declare global {
  const CONFIG: { [key: string]: string };
}

interface Config {
  ALGOLIA_APPLICATION_ID: string;
  ALGOLIA_INDEX_PREFIX: string;
  ALGOLIA_READ_ONLY_API_KEY: string;
  AUTH0_AUDIENCE: string;
  AUTH0_CLIENT_ID: string;
  AUTH0_DOMAIN: string;
  AUTH0_REDIRECT_URI: string;
  GOOGLE_ANALYTICS_GA4_ID: string;
  GOOGLE_API_KEY: string;
  STRAPI_API_TOKEN: string;
  STRAPI_API_URL: string;
}

const config: Config = {
  ALGOLIA_APPLICATION_ID: CONFIG.ALGOLIA_APPLICATION_ID,
  ALGOLIA_INDEX_PREFIX: CONFIG.ALGOLIA_INDEX_PREFIX,
  ALGOLIA_READ_ONLY_API_KEY: CONFIG.ALGOLIA_READ_ONLY_API_KEY,
  AUTH0_AUDIENCE: CONFIG.AUTH0_AUDIENCE,
  AUTH0_CLIENT_ID: CONFIG.AUTH0_CLIENT_ID,
  AUTH0_DOMAIN: CONFIG.AUTH0_DOMAIN,
  AUTH0_REDIRECT_URI: CONFIG.AUTH0_REDIRECT_URI,
  GOOGLE_ANALYTICS_GA4_ID:
    process.env.NODE_ENV === "production" ? CONFIG.GOOGLE_ANALYTICS_GA4_ID : "",
  GOOGLE_API_KEY: CONFIG.GOOGLE_API_KEY,
  STRAPI_API_TOKEN: CONFIG.STRAPI_API_TOKEN,
  STRAPI_API_URL: CONFIG.STRAPI_API_URL,
};

export default config;
